import apiClient from './clients/api-client'
import { API_URL } from '@/config'

const path = `${API_URL}/members`

const client = apiClient.build(path)

export default client
